import { render, staticRenderFns } from "./17PointsModal.vue?vue&type=template&id=1a8df81b&scoped=true&"
import script from "./17PointsModal.vue?vue&type=script&lang=js&"
export * from "./17PointsModal.vue?vue&type=script&lang=js&"
import style0 from "./17PointsModal.vue?vue&type=style&index=0&id=1a8df81b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8df81b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VChip,VIcon,VImg,VProgressCircular,VRadio,VRadioGroup,VTextField})
